var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgP2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 272,
    height: 172,
    viewBox: "0 0 272 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(-410.5 -2001)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_173_women_and_girls",
    "data-name": "173 women and girls",
    transform: "translate(546.5 2087)",
    fill: "#255e1c",
    fontSize: 66,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.06em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -135.663,
    y: 0
  }, "173 WOMEN"), /*#__PURE__*/React.createElement("tspan", {
    x: -128.898,
    y: 62
  }, "AND GIRLS")), /*#__PURE__*/React.createElement("text", {
    id: "were_murdered_in_Canada",
    "data-name": "were murdered in Canada",
    transform: "translate(546.5 2170)",
    fill: "#1d1d1d",
    fontSize: 16,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -90.12,
    y: 0
  }, "were murdered in Canada")), /*#__PURE__*/React.createElement("text", {
    id: "In_2021_",
    "data-name": "In 2021,",
    transform: "translate(546.5 2025)",
    fill: "#1d1d1d",
    fontSize: 20,
    fontFamily: "Oswald-Medium, Oswald",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -31.94,
    y: 0
  }, "IN 2021,")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2);
export default __webpack_public_path__ + "static/media/p2.fa3bd45676bf830dce1fd77af4052be9.svg";
export { ForwardRef as ReactComponent };